import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    reportParams: {},
    branches: [],
    departments: [],
    employees: [],
    leaveTypes: [],
    tableHeading: [],
    employeeData: [],
    leaveData: [],
    reportTotal: 0,
    currentPage: 1,
    perPage: 5,
    tableLoading: false,
    exemptionData: [],
    exemptionReportTotal: 0,
    reportType: null,
    currentPageExemption: 1,
    perPageExemption: 5,
  },
  actions,
  mutations,
};
